import { useEffect, useState } from "react";
import ModalService from "../../utils/modal.service";
import styles from "./Modal.module.scss";

interface IProps {
  id: string;
  children: React.ReactNode;
  onOverlayClick?: () => void;
}

const Modal: React.FC<IProps> = ({ id, children, onOverlayClick }: IProps) => {
  const [open, setOpen] = useState(false);

  const toggle = (state: boolean) => {
    if (state) {
      const scrollBarGap =
        window.innerWidth - document.documentElement.clientWidth;
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = "-" + scrollY + "px";
      document.body.style.width = "calc(100% - " + scrollBarGap + "px)";
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }

    setOpen(state);
  };

  useEffect(() => {
    ModalService.registerModal(id, toggle);

    return () => {
      ModalService.removeModal(id);
    };
  }, [id]);

  return (
    <>
      {open && (
        <>
          <div className={styles.overlay} onClick={onOverlayClick}></div>
          <div id={id} className={styles.modal}>
            {children}
          </div>
        </>
      )}
    </>
  );
};

export default Modal;
